/**
* 配置文件
*/

// 发布配置
const production = {
    BASE: 'production', 
    // node API数据接口配置
    APISERVER: {
        host: basePath
    },
    getApiServerHost() { // 从地址栏拿到数据请求的ip地址--仅开发测试阶段需要
        let urlStr = location.href
        let serverHostIndex = urlStr.indexOf('serverhost')
        if (serverHostIndex !== -1) {
            let urlStr1ubstr = urlStr.substr(serverHostIndex, urlStr.length)
            let urlStrSplit01 = urlStr1ubstr.split('=')[1]
            let apiServerHost = urlStrSplit01.replace('%3A', ':')
            // let apiServerHost = urlStrSplit01.replace(/%2F/g, ':')
            localStorage.setItem('apiServerHost', apiServerHost)
        }
        // else {
        //   localStorage.setItem('apiServerHost', '')
        // }
        // 重新设置配置文件
        this.setApiServerHost()
    },
    setApiServerHost() {
        let apiServerHostTemp = localStorage.getItem('apiServerHost')
        if (apiServerHostTemp) {
            this.APISERVER.host = 'http://' + apiServerHostTemp
        } else {
            this.APISERVER.host = basePath
        }
    }
}

// 开发配置
const development = {
    BASE: 'development', 
    // node API数据接口配置
    APISERVER: {
        host: basePath
    },
    getApiServerHost() { // 从地址栏拿到数据请求的ip地址--仅开发测试阶段需要
        let urlStr = location.href
        let serverHostIndex = urlStr.indexOf('serverhost')
        if (serverHostIndex !== -1) {
            let urlStr1ubstr = urlStr.substr(serverHostIndex, urlStr.length)
            let urlStrSplit01 = urlStr1ubstr.split('=')[1]
            let apiServerHost = urlStrSplit01.replace('%3A', ':')
            // let apiServerHost = urlStrSplit01.replace(/%2F/g, ':')
            localStorage.setItem('apiServerHost', apiServerHost)
        }
        // else {
        //   localStorage.setItem('apiServerHost', '')
        // }
        // 重新设置配置文件
        this.setApiServerHost()
    },
    setApiServerHost() {
        let apiServerHostTemp = localStorage.getItem('apiServerHost')
        if (apiServerHostTemp) {
            this.APISERVER.host = 'http://' + apiServerHostTemp
        } else {
            this.APISERVER.host = basePath
        }
    }
}

const config = process.env.NODE_ENV === 'production' ? production : development

export default config



// WEBPACK FOOTER //
// ./src/config/config.js